module.exports = __webpack_public_path__ + "img/DocNotFound.94e8b396.png";